'use client'

import React from 'react'
import { Calendar } from '@/ui/components/Calendar'
import type { Event } from '@/payload-types'
import type { TypedLocale } from 'payload'

interface CalendarClientProps {
  events: Event[]
  locale?: TypedLocale
}

export function CalendarClient({ events, locale }: CalendarClientProps) {
  return <Calendar events={events} showTitle={false} locale={locale} />
}
